import { render, staticRenderFns } from "./ParticipantInvolvedPerson.vue?vue&type=template&id=c2a069bc"
import script from "./ParticipantInvolvedPerson.vue?vue&type=script&lang=js"
export * from "./ParticipantInvolvedPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports